import axios from 'axios';
import config from './../config';
const getBaseUrl = () => {
  let url;
  switch (process.env.NODE_ENV) {
    case 'production':
      url = config.baseURLProd;
      break;
    case 'development':
    default:
      url = config.baseURLDev;
  }
  return url;
};

const getToken = () => {
  return sessionStorage.getItem('userToken') === undefined
    ? ''
    : sessionStorage.getItem('userToken');
};

export const http = axios.create({
  withCredentials: true,

  baseURL: getBaseUrl(),
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
    Authorization: '',
  },
});

http.interceptors.request.use(function (config) {
  let token = getToken();
  config.headers['Authorization'] = 'Bearer ' + token;
  return config;
});

export const setupInterceptors = (store) => {
  http.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      if (error.response.status === 404) {
        return Promise.reject(error.response.data);
      } else if (
        error.response.status === 403 ||
        error.response.status === 401
      ) {
        return Promise.reject('API is not authorized. Please login');
      } else if (error.response.status === 419) {
        return Promise.reject([]);
      } else if (error.response.status === 400) {
        return Promise.reject(error.response.data);
      } else if (error.response.status === 500) {
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject('An unexpected error has occurred.');
      }
    }
  );
};

export default http;
